import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { stockService } from '../services/api';
import './AddProduct.css';

const AddProduct = () => {
    const navigate = useNavigate();
    const [existingCategories, setExistingCategories] = useState([]);
    const [isNewCategory, setIsNewCategory] = useState(false);

    const [formData, setFormData] = useState({
        ref_produit: '',
        code_barre: '',
        designation: '',
        categorie: '',
        fournisseur: '',
        prix_achat_ht: 0,
        prix_vente_ht: 0,
        stock_actuel: 0,
        stock_min: 2
    });

    // On récupère les catégories au chargement
    useEffect(() => {
        stockService.getAllProducts().then(data => {
            const cats = [...new Set(data.map(p => p.categorie))].filter(Boolean).sort();
            setExistingCategories(cats);
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await stockService.addProduct(formData);
        if (res.success) {
            alert("Produit enregistré avec succès !");
            navigate('/inventory');
        } else {
            alert("Erreur lors de l'ajout");
        }
    };

    return (
        <div className="add-container">
            <h2>Nouveau Produit</h2>
            <form onSubmit={handleSubmit} className="add-form">

                {/* LIGNE CATÉGORIE DYNAMIQUE */}
                <div className="form-group">
                    <label>Catégorie</label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        {!isNewCategory ? (
                            <select
                                className="custom-input"
                                value={formData.categorie}
                                onChange={e => setFormData({ ...formData, categorie: e.target.value })}
                                required
                            >
                                <option value="">-- Choisir une catégorie --</option>
                                {existingCategories.map(cat => (
                                    <option key={cat} value={cat}>{cat}</option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type="text"
                                placeholder="Nom de la nouvelle catégorie"
                                className="custom-input"
                                onChange={e => setFormData({ ...formData, categorie: e.target.value })}
                                required
                            />
                        )}
                        <button
                            type="button"
                            className="btn-small"
                            onClick={() => {
                                setIsNewCategory(!isNewCategory);
                                setFormData({ ...formData, categorie: '' });
                            }}
                        >
                            {isNewCategory ? "Annuler" : "+ Créer"}
                        </button>
                    </div>
                </div>

                <div className="form-group">
                    <label>Désignation du produit</label>
                    <input
                        type="text"
                        placeholder="Ex: Caméra Hikvision IP..."
                        required
                        onChange={e => setFormData({ ...formData, designation: e.target.value })}
                    />
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Référence Interne</label>
                        <input type="text" placeholder="Référence" onChange={e => setFormData({ ...formData, ref_produit: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <label>Code-barre (EAN)</label>
                        <input type="text" placeholder="Gencod" onChange={e => setFormData({ ...formData, code_barre: e.target.value })} />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Prix Achat HT</label>
                        <input type="number" placeholder="0.00" step="0.01" onChange={e => setFormData({ ...formData, prix_achat_ht: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <label>Stock de départ</label>
                        <input type="number" placeholder="Quantité" onChange={e => setFormData({ ...formData, stock_actuel: e.target.value })} />
                    </div>
                </div>

                <button type="submit" className="btn-save">Enregistrer en base</button>
            </form>
        </div>
    );
};

export default AddProduct;